import { WorkflowDestination } from "./items";

// ワークフロー実行内容
export class WorkflowActionContent {
  public triggerCode: number;
  public nextMessageCommentId?: number; // 登録競合チェックで使用
  public nextMessageArchiveId?: number; // 登録競合チェックで使用
  public nextMessage: string;
  public destination: WorkflowDestination;
  public backMessage: string;
  // TODO 他医依頼
  public lastWorkflowHistoryId: string; // データ取得時点の最終WF履歴ID（排他制御用）
}
